<template>
  <div class="border">
    <input type="text" maxlength="2" placeholder="DD" />
    <input type="text" maxlength="2" placeholder="MM" />
    <input type="text" maxlength="4" placeholder="YYYY" />
  </div>
</template>
<script>
export default {
  name: "Datepicker",
  data() {
    return {
      dd: "",
      mm: "",
      yyyy: ""
    };
  }
};
</script>
<style scoped>
.border {
  width: fit-content;
  border: 1px solid gray;
}

.border input {
  background-color: white;
  outline: none;
}

input:nth-child(1) {
  width: 30px;
}

input:nth-child(2) {
  width: 35px;
}

input:nth-child(3) {
  width: 50px;
}
</style>
